import { create } from "zustand";
import { initialState, TTabStore } from "./tab.state";
import { createTabActions } from "./tab.actions";

/**
 * State management store of the V3 search - Tabs data
 * @example
 * ```
 * const tab = useTabStore((state) => state.tab)
 * const dispatch = useTabStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_ACTIVETAB, payload: tabItem })
 * ```
 */
export const useTabStore = create<TTabStore>((set, get) => ({
    ...initialState,
    ...createTabActions(set, get),
}));
